import type { LandingComponents } from "@/puck/blocks/blockTypes";
import { PhoneVideoBlock } from "@/puck/landing/phoneVideoBlock";

export const phoneVideoConfigs: Pick<LandingComponents, "PhoneVideo"> = {
  PhoneVideo: {
    label: "Phone video",
    fields: {
      mediaId: {
        type: "text",
        label: "Wistia media ID (from the video's share/embed URL)",
      },
      autoplay: {
        type: "radio",
        options: [
          { label: "Off", value: false },
          { label: "On muted", value: true },
        ],
      },
      label: {
        type: "text",
        label: "Accessible video label",
      },
    },
    defaultProps: {
      mediaId: "cj25mopmgf",
      autoplay: false,
      label: "Gail filling a COI / ACORD form",
    },
    render: PhoneVideoBlock,
  },
};
